import script from "./FinanzasView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanzasView.vue?vue&type=script&setup=true&lang=js"

import "./FinanzasView.vue?vue&type=style&index=0&id=1400971a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1400971a"]])

export default __exports__